import { useCallback, type ReactNode } from 'react';

import type { GlobalShortcutsItem } from '@atlassian/global-shortcuts';
import type { NavItemConfig } from '@atlassian/navigation-common';

import { getMenuIconAndLabel } from '../../../../common/utils/get-menu-icon-and-label';

export const useGetMenuIconAndLabel = (
	items: Record<string, NavItemConfig>,
	shortcuts: Record<string, GlobalShortcutsItem>,
): ((menuId: string) => {
	icon: ReactNode;
	label: string;
}) =>
	useCallback(
		(menuId: string) => getMenuIconAndLabel(items, shortcuts)(menuId),
		[items, shortcuts],
	);
